import React from 'react';
import Link from 'next/link';
import dayjs from 'dayjs';
import { PostNode } from 'app.type/examsInfo';
import styled from 'styled-components';

type TProps = {
  postsData: PostNode[];
  communityUrl: string;
  boardTitle?: string;
  boardId?: string;
  maxVisiblePosts: number;
  communityBoardSlug: string;
};

const CommunityPostList: React.FC<TProps> = ({
  postsData,
  communityUrl,
  boardTitle,
  boardId,
  maxVisiblePosts,
  communityBoardSlug,
}) => {
  return (
    <StyledWrapper>
      {postsData?.slice(0, maxVisiblePosts).map((post, index) => {
        return (
          <article key={index} className="content-wrapper">
            <header>
              <Link href={`${communityUrl}/${communityBoardSlug}`} target={'_blank'}>
                <span>{boardTitle}</span>
              </Link>
            </header>
            <section className="content-box">
              <Link href={`${communityUrl}/${communityBoardSlug}/${post.id}`} target={'_blank'}>
                <div className="title">
                  <h4>{post?.title}</h4>
                  {post.containsImage && (
                    <span>
                      <img src="/images/community/post-list-pic.png" alt="이미지" />
                    </span>
                  )}
                  {post.containsYoutube && (
                    <span>
                      <img src="/images/community/post-list-youtube.png" alt="유튜브" />
                    </span>
                  )}
                </div>
                <p>{post?.contentText}</p>
              </Link>
            </section>
            <footer>
              <p>
                <span>조회수 {post?.views}</span> <span>댓글 {post?.commentCount}</span>
              </p>
              <p>
                <span>{post?.nickname}</span>
                <span>{dayjs(post.createdAt).format('YYYY-MM-DD')}</span>
              </p>
            </footer>
          </article>
        );
      })}
    </StyledWrapper>
  );
};

export default CommunityPostList;

const StyledWrapper = styled.div`
  .content-wrapper {
    padding: 25px 0;
    border-bottom: 1px solid #e0e0e0;

    header {
      font-size: 14px;
      color: #01a0ff;
      span {
        font-size: 14px;
        color: #333;
        font-weight: 600;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .content-box {
      &:hover {
        text-decoration: underline;
      }
      .title {
        display: flex;
        align-items: center;
        gap: 5px;
        margin: 15px 0 10px;

        h4 {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      p {
        font-size: 14px;
        color: #666;
        font-weight: 500;
        margin-bottom: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      img,
      video {
        max-width: 50%;
        height: auto;
      }
    }

    footer {
      display: flex;
      justify-content: space-between;
      p {
        display: flex;
        gap: 20px;
        align-items: center;
        font-size: 14px;
        color: #888;
        font-weight: 500;
        span {
          position: relative;
          &::after {
            content: '';
            width: 1px;
            height: 10px;
            background-color: #e0e0e0e0;
            position: absolute;
            top: 50%;
            right: -15px;
            transform: translateY(-50%);
            margin: 0 5px;
          }
          &:last-child {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.device.mobile} {
    .content-wrapper {
      padding: 20px 0;
      header {
        span {
          font-size: 12px;
        }
      }

      .content-box {
        h4 {
          font-size: 14px;
          margin: 10px 0 5px;
        }
        p {
          font-size: 12px;
          margin-bottom: 10px;
        }
      }

      footer {
        p {
          font-size: 12px;
          span {
            &::after {
              height: 8px;
            }
          }
        }
      }
    }
  }
`;
